import { giphyDarkestGrey } from '@giphy/js-brand'
import { IGif } from '@giphy/js-types'
import { Button } from 'shared/components/buttons'
import download from 'downloadjs'
import React from 'react'
import sanitize from 'sanitize-filename'
import { trackEvent } from 'shared/util/gif-detail-ga-events'
import styled from 'styled-components'

const Container = styled.div`
    align-items: center;
    background: ${giphyDarkestGrey};
    display: flex;
    font-size: 14px;
    font-weight: bold;
    padding: 10px 10px 10px 12px;
`

const Download = styled(Button)`
    border-radius: 2px;
    margin-left: auto;
`

const getHdUrl = ({ images = {} }: any) => {
    if (images.hd) {
        return images.hd.mp4
    }
    if (images.source?.url.indexOf('.mp4') > -1 || images.source?.url.indexOf('.mov') > -1) {
        return images.source.url
    }
    return null
}

type Props = {
    gif: IGif
}

const GifDetailDownloadBackdrop = ({ gif }: Props) => {
    const hdUrl = getHdUrl(gif)

    const onDownloadClick = async (e) => {
        e.preventDefault()

        // load asset and trigger download
        const gifUrl = hdUrl.replace('media.giphy.com', 'i.giphy.com')
        const result = await fetch(gifUrl)
        const blob = await result.blob()
        trackEvent('Download Backdrop', `${gif.id}`)
        download(blob, sanitize(`${gif.title}-backdrop.mp4`))
    }

    return (
        <Container>
            Use this background in Zoom Meetings!{' '}
            <Download as="a" href={hdUrl} onClick={onDownloadClick}>
                Download
            </Download>
        </Container>
    )
}

export default GifDetailDownloadBackdrop
